import axios from 'axios'
import { config } from '../../config'
import { APP_CONSTANTS } from '../../utils/AppConstants'
import API_ENDPOINTS from './endpoints'

export function addEmployeeAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.addEmployee}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeAttendanceCheckAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.attendancCheck}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeLoginCodeCheckAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.loginCodeCheck}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.employeeList}`,
        params: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeDetailAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.employeeDetail}/${payload}`,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeUpdateDetailsAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.updateDetails}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeClockInAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.clockIn}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeClockOutAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.clockOut}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function removeEmployeeFromBusinessAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.removeFromBusiness}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeDashboardDataAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.dashboardData}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeAttendanceListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.attendanceList}`,
        params: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeAddAvailabilityAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.addAvailability}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function employeeAvailabilityListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.availabilityList}`,
        params: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}
export function employeeUpdateAvailabilityAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.employee.updateAvailability}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}